import { useMemo } from 'react'

import { useFilters, useModals, useSetState } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'
import type { PageContextPayload } from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import EditApiLogModal from '@modals/EditApiLogModal'

import { ApiLogModel } from '@models/types'

import PageContent from './components/PageContent'

const defaultState = {
  showEditApiLogModal: false,
}

type SetState = (state: Partial<typeof defaultState>) => void

const callbacks = <ModalName extends keyof typeof componentCallbacks>(component: ModalName, setState: SetState) => {
  const componentCallbacks = {
    EditApiLogModal: {
      closeModal: () => setState({ showEditApiLogModal: false }),
      updateApiLog: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}

const List = () => {
  const [state, setState] = useSetState(defaultState)
  const { showEditApiLogModal } = state

  const {
    callbacks: filterCallbacks,
    defaultFilters,
    pageFilters,
  } = useFilters()

  const modalContext = useModals({ setState })
  const {
    callbacks: { setModalData },
  } = modalContext

  const pageContext: PageContextPayload = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
      showEditApiLogModal: (payload: { apiLog: ApiLogModel }) => {
        setModalData('EditApiLogModal', payload)
        setState({ showEditApiLogModal: true })
      },
    },
    defaultFilters,
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent pageFilters={pageFilters} />

        <EditApiLogModal
          callbacks={callbacks('EditApiLogModal', setState)}
          showModal={showEditApiLogModal}
        />

      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
